module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('job-list', {
    ref: "jobList"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.salesChannels), function(channel) {
    return _c('div', {
      key: channel.key,
      staticClass: "col-md-6 col-xl-3"
    }, [_c('sales-channel-widget', {
      attrs: {
        "sales-channel": channel
      },
      on: {
        "sync": _vm.loadJobList
      }
    })], 1)
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-share mr-5"
  }), _vm._v(" Verkoopkanalen\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92894cd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sales-channels/SalesChannelsPage.vue
// module id = 744
// module chunks = 1